import { createContext, useContext } from 'react';

export const StudioSummaryContext = createContext();

export const useStudioSummary = () => useContext(StudioSummaryContext);

export const StudioSummaryModalType = {
	SUMMARY: 'SUMMARY',
};
